import Vue from 'vue';

Vue.filter('thousands', value => {
  let re =''
    if(!value) return re;
    if(typeof(value)=='number'){
      value=`${value}`
    }
    re = value.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    return re;
});
